import { render, staticRenderFns } from "./BotViewHeader.vue?vue&type=template&id=06daf0e2&scoped=true&"
import script from "./BotViewHeader.vue?vue&type=script&lang=js&"
export * from "./BotViewHeader.vue?vue&type=script&lang=js&"
import style0 from "./BotViewHeader.vue?vue&type=style&index=0&id=06daf0e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06daf0e2",
  null
  
)

export default component.exports